"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LISTBOX_DROPDOWN_HEIGHT = exports.buttonInputFieldIconSizes = exports.BORDER_ALTERNATIVE = exports.BUTTON_FORM_FIELDS_PADDING = exports.BORDERS = exports.SHADOWS = exports.TYPOGRAPHY = exports.COLOURS = exports.BREAKPOINTS = exports.SIZES = exports.BASE = void 0;
const getDesignToken_1 = require("../utils/getDesignToken");
/**
 * @deprecated Use CSS variables instead
 */
exports.BASE = {
    grid: 8,
    font: `'Roboto', sans-serif`,
};
/**
 * @deprecated Use rem values directly. SIZES[x] is equivalent to `${x/2}rem`. e.g. SIZES[1] === "0.5rem"
 */
exports.SIZES = {
    0.25: `${exports.BASE.grid * 0.25}px`, // 2px
    0.5: `${exports.BASE.grid * 0.5}px`, // 4px
    1: `${exports.BASE.grid}px`, // 8px
    1.5: `${exports.BASE.grid * 1.5}px`, // 12px
    2: `${exports.BASE.grid * 2}px`, // 16px
    3: `${exports.BASE.grid * 3}px`, // 24px
    4: `${exports.BASE.grid * 4}px`, // 32px
    5: `${exports.BASE.grid * 5}px`, // 40px
    6: `${exports.BASE.grid * 6}px`, // 48px
    7: `${exports.BASE.grid * 7}px`, // 56px
    8: `${exports.BASE.grid * 8}px`, // 64px
};
// Match bootstrap 4.0 breakpoints
exports.BREAKPOINTS = {
    // Extra small screen / phone
    xs: "0",
    // Small screen / phone
    sm: "576px",
    // Medium screen / tablet
    md: "768px",
    // Large screen / desktop
    lg: "992px",
    // Extra large screen / wide desktop
    xl: "1200px",
};
/**
 * @deprecated Use CSS variables instead
 */
exports.COLOURS = {
    greyscale: {
        night: (0, getDesignToken_1.getDesignToken)("colour.greyscale.night"),
        zinc: (0, getDesignToken_1.getDesignToken)("colour.greyscale.zinc"),
        metal: (0, getDesignToken_1.getDesignToken)("colour.greyscale.metal"),
        stone: (0, getDesignToken_1.getDesignToken)("colour.greyscale.stone"),
        silver: (0, getDesignToken_1.getDesignToken)("colour.greyscale.silver"),
        dishwater: (0, getDesignToken_1.getDesignToken)("colour.greyscale.dishwater"),
        cloud: (0, getDesignToken_1.getDesignToken)("colour.greyscale.cloud"),
        white: (0, getDesignToken_1.getDesignToken)("colour.greyscale.white"),
    },
    primary: {
        green: {
            130: (0, getDesignToken_1.getDesignToken)("colour.primary.green.130"),
            100: (0, getDesignToken_1.getDesignToken)("colour.primary.green.100"),
            75: (0, getDesignToken_1.getDesignToken)("colour.primary.green.75"),
            50: (0, getDesignToken_1.getDesignToken)("colour.primary.green.50"),
            25: (0, getDesignToken_1.getDesignToken)("colour.primary.green.25"),
            10: (0, getDesignToken_1.getDesignToken)("colour.primary.green.10"),
            5: (0, getDesignToken_1.getDesignToken)("colour.primary.green.5"),
        },
        blue: {
            130: (0, getDesignToken_1.getDesignToken)("colour.primary.blue.130"),
            100: (0, getDesignToken_1.getDesignToken)("colour.primary.blue.100"),
            75: (0, getDesignToken_1.getDesignToken)("colour.primary.blue.75"),
            50: (0, getDesignToken_1.getDesignToken)("colour.primary.blue.50"),
            25: (0, getDesignToken_1.getDesignToken)("colour.primary.blue.25"),
            10: (0, getDesignToken_1.getDesignToken)("colour.primary.blue.10"),
            5: (0, getDesignToken_1.getDesignToken)("colour.primary.blue.5"),
        },
        red: {
            130: (0, getDesignToken_1.getDesignToken)("colour.primary.red.130"),
            100: (0, getDesignToken_1.getDesignToken)("colour.primary.red.100"),
            75: (0, getDesignToken_1.getDesignToken)("colour.primary.red.75"),
            50: (0, getDesignToken_1.getDesignToken)("colour.primary.red.50"),
            25: (0, getDesignToken_1.getDesignToken)("colour.primary.red.25"),
            10: (0, getDesignToken_1.getDesignToken)("colour.primary.red.10"),
            5: (0, getDesignToken_1.getDesignToken)("colour.primary.red.5"),
        },
        yellow: {
            130: (0, getDesignToken_1.getDesignToken)("colour.primary.yellow.130"),
            100: (0, getDesignToken_1.getDesignToken)("colour.primary.yellow.100"),
            75: (0, getDesignToken_1.getDesignToken)("colour.primary.yellow.75"),
            50: (0, getDesignToken_1.getDesignToken)("colour.primary.yellow.50"),
            25: (0, getDesignToken_1.getDesignToken)("colour.primary.yellow.25"),
            10: (0, getDesignToken_1.getDesignToken)("colour.primary.yellow.10"),
            5: (0, getDesignToken_1.getDesignToken)("colour.primary.yellow.5"),
        },
        orange: {
            130: (0, getDesignToken_1.getDesignToken)("colour.secondary.orange.130"),
            100: (0, getDesignToken_1.getDesignToken)("colour.secondary.orange.100"),
            75: (0, getDesignToken_1.getDesignToken)("colour.secondary.orange.75"),
            50: (0, getDesignToken_1.getDesignToken)("colour.secondary.orange.50"),
            25: (0, getDesignToken_1.getDesignToken)("colour.secondary.orange.25"),
            10: (0, getDesignToken_1.getDesignToken)("colour.secondary.orange.10"),
            5: (0, getDesignToken_1.getDesignToken)("colour.secondary.orange.5"),
        },
        pink: {
            130: (0, getDesignToken_1.getDesignToken)("colour.secondary.pink.130"),
            100: (0, getDesignToken_1.getDesignToken)("colour.secondary.pink.100"),
            75: (0, getDesignToken_1.getDesignToken)("colour.secondary.pink.75"),
            50: (0, getDesignToken_1.getDesignToken)("colour.secondary.pink.50"),
            25: (0, getDesignToken_1.getDesignToken)("colour.secondary.pink.25"),
            10: (0, getDesignToken_1.getDesignToken)("colour.secondary.pink.10"),
            5: (0, getDesignToken_1.getDesignToken)("colour.secondary.pink.5"),
        },
        purple: {
            130: (0, getDesignToken_1.getDesignToken)("colour.secondary.purple.130"),
            100: (0, getDesignToken_1.getDesignToken)("colour.secondary.purple.100"),
            75: (0, getDesignToken_1.getDesignToken)("colour.secondary.purple.75"),
            50: (0, getDesignToken_1.getDesignToken)("colour.secondary.purple.50"),
            25: (0, getDesignToken_1.getDesignToken)("colour.secondary.purple.25"),
            10: (0, getDesignToken_1.getDesignToken)("colour.secondary.purple.10"),
            5: (0, getDesignToken_1.getDesignToken)("colour.secondary.purple.5"),
        },
    },
    transparent: (0, getDesignToken_1.getDesignToken)("colour.transparent"),
};
/**
 * @deprecated Use CSS variables instead
 */
exports.TYPOGRAPHY = {
    title: {
        base: {
            fontWeight: 700,
            fontFamily: exports.BASE.font,
            fontStyle: "normal",
            color: exports.COLOURS.greyscale.night,
        },
        desktop: {
            fontSize: "2rem",
            lineHeight: "2.5rem",
            marginTop: "1rem",
            marginBottom: "0.75rem",
        },
        mobile: {
            fontSize: "1.5rem",
            lineHeight: "2rem",
            marginTop: "1rem",
            marginBottom: "0.75rem",
        },
    },
    subtitle: {
        base: {
            fontWeight: 700,
            fontFamily: exports.BASE.font,
            fontStyle: "normal",
            color: exports.COLOURS.greyscale.night,
        },
        desktop: {
            fontSize: "1.25rem",
            lineHeight: "2rem",
            marginTop: "0.75rem",
            marginBottom: "0",
        },
        mobile: {
            fontSize: "1.125rem",
            lineHeight: "1.5rem",
            marginTop: "0.75rem",
            marginBottom: "0",
        },
    },
    label: {
        base: {
            fontWeight: 700,
            fontFamily: exports.BASE.font,
            fontStyle: "normal",
            color: exports.COLOURS.greyscale.night,
        },
        desktop: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            marginTop: "0.25rem",
            marginBottom: "0",
        },
        mobile: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            marginTop: "0.25rem",
            marginBottom: "0",
        },
    },
    body: {
        base: {
            fontWeight: 400,
            fontFamily: exports.BASE.font,
            fontStyle: "normal",
            color: exports.COLOURS.greyscale.zinc,
        },
        desktop: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            marginTop: "0.25rem",
            marginBottom: "0.75rem",
        },
        mobile: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            marginTop: "0.25rem",
            marginBottom: "0.75rem",
        },
    },
    link: {
        base: {
            fontWeight: 400,
            fontFamily: exports.BASE.font,
            textDecoration: "underline",
            color: exports.COLOURS.primary.blue[100],
        },
        desktop: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            marginTop: "0.25rem",
            marginBottom: "0.75rem",
        },
        mobile: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            marginTop: "0.25rem",
            marginBottom: "0.75rem",
        },
    },
    note: {
        base: {
            fontWeight: 700,
            fontFamily: exports.BASE.font,
            fontStyle: "normal",
            color: exports.COLOURS.greyscale.night,
        },
        desktop: {
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            marginTop: "0.25rem",
            marginBottom: "0.25rem",
        },
        mobile: {
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            marginTop: "0.25rem",
            marginBottom: "0.25rem",
        },
    },
    preview: {
        base: {
            fontWeight: 400,
            fontFamily: exports.BASE.font,
            fontStyle: "normal",
            color: exports.COLOURS.greyscale.night,
        },
        desktop: {
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            marginTop: "0.25rem",
            marginBottom: "0.25rem",
        },
        mobile: {
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            marginTop: "0.25rem",
            marginBottom: "0.25rem",
        },
    },
    caption: {
        base: {
            fontWeight: 700,
            fontFamily: exports.BASE.font,
            textTransform: "uppercase",
            color: exports.COLOURS.greyscale.metal,
        },
        desktop: {
            fontSize: "0.6875rem",
            lineHeight: "1rem",
            marginTop: "0.25rem",
            marginBottom: "0.25rem",
        },
        mobile: {
            fontSize: "0.6875rem",
            lineHeight: "1rem",
            marginTop: "0.25rem",
            marginBottom: "0.25rem",
        },
    },
};
/**
 * 🤔 FOR ANY BOX SHADOWS THAT DON'T CONFORM TO THESE STANDARD VALUES, PLEASE USE THE "setBoxShadow" IN ./helper.ts.  ✅
 */
exports.SHADOWS = {
    raised: {
        high: {
            silver: `0px 4px 0px ${exports.COLOURS.greyscale.silver}`,
            blue: `0px 4px 0px ${exports.COLOURS.primary.blue["130"]}`,
            red: `0px 4px 0px ${exports.COLOURS.primary.red["130"]}`,
            green: `0px 4px 0px ${exports.COLOURS.primary.green["130"]}`,
        },
        medium: {
            silver: `0px 2px 0px ${exports.COLOURS.greyscale.silver}`,
            blue: `0px 2px 0px ${exports.COLOURS.primary.blue["130"]}`,
            red: `0px 2px 0px ${exports.COLOURS.primary.red["130"]}`,
            green: `0px 2px 0px ${exports.COLOURS.primary.green["130"]}`,
        },
        low: {
            silver: `0px 1px 0px ${exports.COLOURS.greyscale.silver}`,
            blue: `0px 1px 0px ${exports.COLOURS.primary.blue["130"]}`,
            red: `0px 1px 0px ${exports.COLOURS.primary.red["130"]}`,
            green: `0px 1px 0px ${exports.COLOURS.primary.green["130"]}`,
        },
    },
    raisedInset: {
        high: {
            silver: `inset 0px -4px 0px ${exports.COLOURS.greyscale.silver};`,
            blue: `inset 0px -4px 0px ${exports.COLOURS.primary.blue[130]};`,
            red: `inset 0px -4px 0px ${exports.COLOURS.primary.red[130]};`,
            green: `inset 0px -4px 0px ${exports.COLOURS.primary.green[130]};`,
        },
        medium: {
            silver: `inset 0px -2px 0px ${exports.COLOURS.greyscale.silver};`,
            blue: `inset 0px -2px 0px ${exports.COLOURS.primary.blue[130]};`,
            red: `inset 0px -2px 0px ${exports.COLOURS.primary.red[130]};`,
            green: `inset 0px -2px 0px ${exports.COLOURS.primary.green[130]};`,
        },
    },
    lowered: {
        deep: {
            silver: `inset 0px 4px 0px ${exports.COLOURS.greyscale.silver}`,
            metal: `inset 0px 4px 0px ${exports.COLOURS.greyscale.metal}`,
            blue: `inset 0px 4px 0px ${exports.COLOURS.primary.blue[130]}`,
            red: `inset 0px 4px 0px ${exports.COLOURS.primary.red[130]}`,
        },
        shallow: {
            silver: `inset 0px 2px 0px ${exports.COLOURS.greyscale.silver}`,
            metal: `inset 0px 2px 0px ${exports.COLOURS.greyscale.metal}`,
            blue: `inset 0px 2px 0px ${exports.COLOURS.primary.blue[130]}`,
            red: `inset 0px 2px 0px ${exports.COLOURS.primary.red[130]}`,
        },
    },
    floating: {
        high: `0px 8px 16px rgba(${exports.COLOURS.greyscale.metal}, 0.15)`,
        low: `0px 4px 8px rgba(${exports.COLOURS.greyscale.metal}, 0.15)`,
    },
};
/**
 * @deprecated Use CSS variables instead
 */
exports.BORDERS = {
    radius: exports.SIZES[0.5],
    normal: {
        stone: `1px solid ${exports.COLOURS.greyscale.stone}`,
        silver: `1px solid ${exports.COLOURS.greyscale.silver}`,
        metal: `1px solid ${exports.COLOURS.greyscale.metal}`,
        night: `1px solid ${exports.COLOURS.greyscale.night}`,
        yellow: `1px solid ${exports.COLOURS.primary.yellow["130"]}`,
        blue: `1px solid ${exports.COLOURS.primary.blue["130"]}`,
        red: `1px solid ${exports.COLOURS.primary.red["130"]}`,
        green: `1px solid ${exports.COLOURS.primary.green["130"]}`,
        orange: `1px solid ${exports.COLOURS.primary.orange["130"]}`,
        pink: `1px solid ${exports.COLOURS.primary.pink["130"]}`,
        purple: `1px solid ${exports.COLOURS.primary.purple["130"]}`,
        transparent: `1px solid ${exports.COLOURS.transparent}`,
    },
    soft: {
        silver: `1px solid ${exports.COLOURS.greyscale.silver}`,
        metal: `1px solid ${exports.COLOURS.greyscale.metal}`,
        stone: `1px solid ${exports.COLOURS.greyscale.stone}`,
        yellow: `1px solid ${exports.COLOURS.primary.yellow["25"]}`,
        blue: `1px solid ${exports.COLOURS.primary.blue["25"]}`,
        red: `1px solid ${exports.COLOURS.primary.red["25"]}`,
        green: `1px solid ${exports.COLOURS.primary.green["25"]}`,
        orange: `1px solid ${exports.COLOURS.primary.orange["25"]}`,
        pink: `1px solid ${exports.COLOURS.primary.pink["25"]}`,
        purple: `1px solid ${exports.COLOURS.primary.purple["25"]}`,
        transparent: `1px solid ${exports.COLOURS.transparent}`,
    },
};
exports.BUTTON_FORM_FIELDS_PADDING = {
    text: {
        large: `${exports.SIZES["1.5"]} ${exports.SIZES["2"]}`,
        medium: `${exports.SIZES["1"]} ${exports.SIZES["1.5"]}`,
        small: `${exports.SIZES["0.25"]} ${exports.SIZES["1"]}`,
    },
    textWithIcon: {
        large: `${exports.SIZES["1.5"]} ${exports.SIZES["1.5"]}`,
        medium: `${exports.SIZES["1"]} ${exports.SIZES["1.5"]}`,
        small: `${exports.SIZES["0.25"]} ${exports.SIZES["1"]}`,
    },
    icon: {
        large: `${exports.SIZES["1"]}`,
        medium: `${exports.SIZES["1"]}`,
        small: `${exports.SIZES["0.5"]}`,
    },
};
// If we cannot use a border (i.e. Button or Input) we use this alternative - to be applied to :before or :after pseudo elements
exports.BORDER_ALTERNATIVE = {
    content: "''",
    position: "absolute",
    width: "100%",
    height: "100%",
    display: "block",
    top: 0,
    left: 0,
};
exports.buttonInputFieldIconSizes = {
    large: {
        withText: 3,
        default: 4,
    },
    medium: {
        withText: 3,
        default: 3,
    },
    small: {
        withText: 2,
        default: 2,
    },
};
exports.LISTBOX_DROPDOWN_HEIGHT = "20rem";
//# sourceMappingURL=tokens.js.map